<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getPath } from '../../utils/imageKit.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    image = undefined,
    headingText = undefined,
    headingLevel = 'h3',
    content = undefined,
    link = undefined,
    dataTestId = 'content-large-blurb',
  } = $props();

  // Handle Image Setup
  const defaultSrc = getPath(image, { w: 184 });
  const highResSrc = getPath(image, { w: 184 }, 2);
</script>

<div class="my-4 px-4 flex flex-col items-center max-w-88 mx-auto" data-testid={dataTestId}>
  {#if image && image.url && image.alt}
    <div class="w-20 md:w-28">
      <img
        class="object-contain object-left h-full w-46"
        height="100%"
        width="184"
        src={defaultSrc}
        alt={image.alt}
        srcset={`${defaultSrc}, ${highResSrc} 2x`}
        sizes="184px"
      />
    </div>
  {/if}
  {#if headingText}
    <BaseHeading
      className="mt-4 text-center leading-tight font-medium text-blue-dark-navy text-lg lg:text-xl"
      {headingLevel}
    >
      {headingText}
    </BaseHeading>
  {/if}

  {#if content}
    <div class="mt-4 text-center text-blue-navy">
      {@html content}
    </div>
  {/if}
  {#if link && link.text && link.url}
    <div class="mt-4">
      <BaseLink
        className="leading-normal font-medium text-blue-cerulean hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline
        inline-flex justify-start items-baseline flex-row w-auto"
        {...link}
      >
        <span>{link.text}</span>
        <svg class="ml-3 h-3 w-3 mt-1 fill-current">
          <use xlink:href={`${SPRITESHEET_URL}#right-arrow`} />
        </svg>
      </BaseLink>
    </div>
  {/if}
</div>
